// extracted by mini-css-extract-plugin
export default {"zoomControls":"C_-z","zoomControlButton":"D_-z","zoomBanner":"E_-z","bannerButton":"F_-z","imageButton":"G_-z","zoom":"H_-z","zoomContent":"I_-z"};